import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyTrackingType = ({
    field: { name, value },
    form: { setFieldValue },
    ...props
}) => {
    const [contents, setcontents] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        ReadAxios({ url: 'trackingTypeMaster/' })
            .then((result) => {
                result?.data?.resultSet?.length && setcontents(result?.data?.resultSet)
                setloading(false)
            })
    }, [])

    let options = []
    if (contents.length > 0) {
        contents.map((object, index) => {
            let temp = {}
            temp.key = object.trackingTypeId
            temp.text = object.trackingType
            temp.value = object.trackingTypeId
            temp.image = {
                avatar: true,
                src: object.trackingTypeId === 1 ? 'assets/svg/speed.svg' : '' || object.trackingTypeId === 2 ? 'assets/svg/radar.svg' : '' || object.trackingTypeId === 4 ? 'assets/svg/trace.svg' : '',
                width: '20px'
            }
            return options[index] = temp
        })
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={options}
            {...props}
        />

    )
}

export default MyTrackingType